import { render } from "./editUserComponent.vue?vue&type=template&id=227b4722&scoped=true"
import script from "./editUserComponent.vue?vue&type=script&lang=js"
export * from "./editUserComponent.vue?vue&type=script&lang=js"

import "./editUserComponent.vue?vue&type=style&index=0&id=227b4722&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227b4722"]])

export default __exports__